export default {
  common: {
    regionZone: "Region/Zone",
    seller: "Seller",
    chillerOrPlant: "Objective",
    dateRange: "Date range",
    showNumber: "Show number",
    hallOfFame: "Hall of fame",
    statisticChart: "Statistic chart",
    win: "Win",
    pipeline: "Pipeline",

    chillerAndChillerPlant: "Chiller & Chiller plant",

    chiller: "Chiller efficiency",
    chillerPlant: "Chiller plant efficiency",
    heating: "Heating efficiency",

    ChillerRetrofit: "Chiller retrofit",
    ChillerPlantRetrofit: "Chiller plant retrofit",
    HeatingElectricRetrofit: "Boiler to heat pump retrofit",

    regions: "Regions",
    zones: "Zones",

    resetPipelineCheckMesg:
      "The system is about to replace last month's snapshot data with the current pipeline data. This operation is irreversible. Are you sure you want to perform this operation?",
    resetPipeline: "Reset pipeline",
    resetLastMonthPipelinedata: "Reset last month pipeline data",
    verificationCode: "Verification code",
    enterVerificationCode: "Please enter the verification code to confirm your operation",
    verificationCodeError: "Verification code is error",

    note: "Note",
    dataBefore202601: "The data for January 2026 and earlier are from version 1.0 and currently do not support conditional queries for 'project status' and' project objectives'.",
    iKnowThis: "Close",

    availableWhen202602: "Available when the date range is from Feb 2026 onward"
  }
}



// WEBPACK FOOTER //
// ./src/locale/dashboard/en.js